import { RichText } from '../i18n/RichText';
import { isolate } from '../i18n/translate';
import { t } from '../services/language-manager';

interface InstallSummaryPageProps {
  onInstall: () => void;
  onBack: () => void;
  isInstalling: boolean;
  orgName: string;
  dataRegion: string;
}

export function InstallSummaryPage({ onInstall, onBack, isInstalling, orgName, dataRegion }: InstallSummaryPageProps) {
  return (
    <div className="card">
      <div className="card__title">{t('summary-title')}</div>
      <div className="card__subtitle">
        <RichText k="summary-subtitle" values={{ org: <strong>{isolate(orgName)}</strong> }} />
      </div>

      <div className="summary-item">
        <div className="summary-item__title">
          <RichText
            k="summary-region"
            values={{
              label: t('setup-data-region'),
              region: dataRegion === 'EU' ? t('setup-region-eu') : t('setup-region-us'),
            }}
          />
        </div>
      </div>

      <div className="summary-item">
        <div className="summary-item__title">
          <RichText k="summary-oauth" values={{ name: <strong>{t('summary-oauth-name')}</strong> }} />
        </div>
        <div className="summary-item__description">{t('summary-oauth-description')}</div>
      </div>

      <div className="btn-group">
        <button className="btn btn--secondary" onClick={onBack} disabled={isInstalling}>
          {t('summary-back')}
        </button>
        <button className="btn btn--primary" onClick={onInstall} disabled={isInstalling}>
          {isInstalling ? (
            <>
              <span className="spinner" style={{ width: '16px', height: '16px', borderWidth: '2px' }} />
              {t('loading-installing')}
            </>
          ) : (
            t('summary-install')
          )}
        </button>
      </div>
    </div>
  );
}
